export default "__VITE_ASSET__DBpnrm7K__"